"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_FILE_SIZE = void 0;
exports.MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 Mb
